import { BaseGlobalOperationsUrl, BaseGlobalConfigurationsUrl, BaseGlobalPassengerAppUrl } from './../menus/__base';

import Regions from '@/pages/GlobalPages/Regions';
import Countries from '@/pages/GlobalPages/Countries';
import Cities from '@/pages/GlobalPages/Cities';
import AdminMembers from '@/pages/GlobalPages/AdminUsers';
import AccessControlPage from '@/pages/GlobalPages/AccessControl';
import PartnersPage from '@/pages/GlobalPages/Partners';
import CompaniesPage from '@/pages/GlobalPages/Companies';
import PassengersPage from '@/pages/GlobalPages/Passengers';
import ServicesPage from '@/pages/GlobalPages/Services';
import PlansPage from '@/pages/GlobalPages/Plans';
import SoftwareComponentsPage from '@/pages/GlobalPages/SoftwareComponents';
import PassengerDiscountPage from '@/pages/GlobalPages/PassengerApp/Discount';
import PassengerBookingPage from '@/pages/GlobalPages/PassengerApp/Bookings/BookingPage';
import PassengerSettingsPage from '@/pages/GlobalPages/PassengerApp/PassengerAppSettings';
import GlobalNotificationsPage from '@/pages/GlobalPages/Notifications';
import GlobalStationPage from '@/pages/GlobalPages/Stations';
import GlobalRegistersPage from '@/pages/GlobalPages/Registers';
import GlobalSettingsPage from '@/pages/GlobalPages/GlobalSetting';
import CompanyRolePage from '@/pages/GlobalPages/CompanyRoles';
import GlobalDashboard from '@/pages/GlobalPages/Dashboard';
import { GLOBAL_APP_PERMISSIONS } from '@/services/roleService';
import ManageTemplatePage from '@/pages/GlobalPages/Templates';
import AdvertisingPage from '@/pages/GlobalPages/PassengerApp/Advertising';
import PassengerAppUserPage from '@/pages/GlobalPages/PassengerApp/PassengerAppUsers';

type RouteType = {
  path: string;
  component: any;
  exact: boolean;
  permissions?: string[] | '*';
};

// ------------------------------------------------------
export const defaultRouter = '/cms';

export const GlobalUrl = {
  Operations: {
    Dashboard: `${BaseGlobalOperationsUrl}/dashboard`,
    AdminUsers: `${BaseGlobalOperationsUrl}/admin-users`,
    AccessControl: `${BaseGlobalOperationsUrl}/access-control`,
    Partners: `${BaseGlobalOperationsUrl}/partners`,
    Companies: `${BaseGlobalOperationsUrl}/companies`,
    Passengers: `${BaseGlobalOperationsUrl}/passengers`,
    Notification: `${BaseGlobalOperationsUrl}/notifications`,
    CompanyRole: `${BaseGlobalOperationsUrl}/company-roles`,
  },

  // operations
  Configurations: {
    Dashboard: `${BaseGlobalConfigurationsUrl}/dashboard`,
    Countries: `${BaseGlobalConfigurationsUrl}/country-city-region/countries`,
    Regions: `${BaseGlobalConfigurationsUrl}/country-city-region/regions`,
    Cities: `${BaseGlobalConfigurationsUrl}/country-city-region/cities`,
    Services: `${BaseGlobalConfigurationsUrl}/services`,
    Plans: `${BaseGlobalConfigurationsUrl}/plans`,
    SoftwareComponents: `${BaseGlobalConfigurationsUrl}/software-components`,
    Stations: `${BaseGlobalConfigurationsUrl}/stations`,
    Registers: `${BaseGlobalConfigurationsUrl}/registers`,
    GlobalSettings: `${BaseGlobalConfigurationsUrl}/global-settings`,
    ManageTemplates: `${BaseGlobalConfigurationsUrl}/manage-templates`,
  },
  // PassengerApp
  PassengerApp: {
    Dashboard: `${BaseGlobalPassengerAppUrl}/dashboard`,
    Discounts: `${BaseGlobalPassengerAppUrl}/discounts`,
    Bookings: `${BaseGlobalPassengerAppUrl}/bookings`,
    Settings: `${BaseGlobalPassengerAppUrl}/settings`,
    Advertising: `${BaseGlobalPassengerAppUrl}/advertising`,
    Passengers: `${BaseGlobalPassengerAppUrl}/passengers`,
  },
};

export const GlobalPermissionConfig = {
  // Operations
  [GlobalUrl.Operations.Dashboard]: [GLOBAL_APP_PERMISSIONS.ViewDashboard],
  [GlobalUrl.Operations.AdminUsers]: [GLOBAL_APP_PERMISSIONS.ManageGlobalUsers],
  [GlobalUrl.Operations.AccessControl]: [GLOBAL_APP_PERMISSIONS.ManageAccessControl],
  [GlobalUrl.Operations.Partners]: [GLOBAL_APP_PERMISSIONS.ManagePartners],
  [GlobalUrl.Operations.Companies]: [GLOBAL_APP_PERMISSIONS.ManageCompanies],
  [GlobalUrl.Operations.Passengers]: [GLOBAL_APP_PERMISSIONS.ManagePrismePassengers],
  [GlobalUrl.Operations.Notification]: [GLOBAL_APP_PERMISSIONS.ViewNotifications],
  [GlobalUrl.Operations.CompanyRole]: [GLOBAL_APP_PERMISSIONS.ManageCompanies],

  // operations
  [GlobalUrl.Configurations.Dashboard]: [GLOBAL_APP_PERMISSIONS.ViewDashboard],
  [GlobalUrl.Configurations.Countries]: [GLOBAL_APP_PERMISSIONS.ManageGeoMaster],
  [GlobalUrl.Configurations.Regions]: [GLOBAL_APP_PERMISSIONS.ManageGeoMaster],
  [GlobalUrl.Configurations.Cities]: [GLOBAL_APP_PERMISSIONS.ManageGeoMaster],
  [GlobalUrl.Configurations.Services]: [GLOBAL_APP_PERMISSIONS.ManageServices],
  [GlobalUrl.Configurations.Plans]: [GLOBAL_APP_PERMISSIONS.ManagePlans],
  [GlobalUrl.Configurations.SoftwareComponents]: [GLOBAL_APP_PERMISSIONS.ManageSoftwareComponents],
  [GlobalUrl.Configurations.Stations]: [GLOBAL_APP_PERMISSIONS.ViewStationsOnly, GLOBAL_APP_PERMISSIONS.ManageStations],
  [GlobalUrl.Configurations.Registers]: [GLOBAL_APP_PERMISSIONS.ManageRegisters],
  [GlobalUrl.Configurations.GlobalSettings]: [GLOBAL_APP_PERMISSIONS.ManageGlobalSettings],
  [GlobalUrl.Configurations.ManageTemplates]: [GLOBAL_APP_PERMISSIONS.ManageTemplates],
  // PassengerApp
  [GlobalUrl.PassengerApp.Dashboard]: [GLOBAL_APP_PERMISSIONS.ViewDashboard],
  [GlobalUrl.PassengerApp.Discounts]: [GLOBAL_APP_PERMISSIONS.ManageDiscounts],
  [GlobalUrl.PassengerApp.Bookings]: [GLOBAL_APP_PERMISSIONS.ManagePrismeBookings],
  [GlobalUrl.PassengerApp.Settings]: [GLOBAL_APP_PERMISSIONS.ManagePrismeAppSettings],
  [GlobalUrl.PassengerApp.Passengers]: [GLOBAL_APP_PERMISSIONS.ManagePrismePassengers],

  __getPermission(url: string) {
    return (this[url] || ['*']) as any;
  },
};
const routes: Array<RouteType> = [
  // operations
  { path: GlobalUrl.Operations.Dashboard, component: GlobalDashboard, exact: true },
  { path: GlobalUrl.Operations.AdminUsers, component: AdminMembers, exact: true },
  { path: GlobalUrl.Operations.AccessControl, component: AccessControlPage, exact: true },
  { path: GlobalUrl.Operations.Partners, component: PartnersPage, exact: true },
  { path: GlobalUrl.Operations.Companies, component: CompaniesPage, exact: true },
  { path: GlobalUrl.Operations.Passengers, component: PassengersPage, exact: true },
  { path: GlobalUrl.Operations.Notification, component: GlobalNotificationsPage, exact: true },
  { path: GlobalUrl.Operations.CompanyRole, component: CompanyRolePage, exact: true },

  // configurations
  { path: GlobalUrl.Configurations.Dashboard, component: GlobalDashboard, exact: true },
  { path: GlobalUrl.Configurations.Countries, component: Countries, exact: true },
  { path: GlobalUrl.Configurations.Regions, component: Regions, exact: true },
  { path: GlobalUrl.Configurations.Cities, component: Cities, exact: true },
  { path: GlobalUrl.Configurations.Services, component: ServicesPage, exact: true },
  { path: GlobalUrl.Configurations.Plans, component: PlansPage, exact: true },
  { path: GlobalUrl.Configurations.SoftwareComponents, component: SoftwareComponentsPage, exact: true },
  { path: GlobalUrl.Configurations.Stations, component: GlobalStationPage, exact: true },
  { path: GlobalUrl.Configurations.Registers, component: GlobalRegistersPage, exact: true },
  { path: GlobalUrl.Configurations.GlobalSettings, component: GlobalSettingsPage, exact: true },
  { path: GlobalUrl.Configurations.ManageTemplates, component: ManageTemplatePage, exact: true },

  // monitoring

  // passengerApp
  { path: GlobalUrl.PassengerApp.Discounts, component: PassengerDiscountPage, exact: true },
  { path: GlobalUrl.PassengerApp.Bookings, component: PassengerBookingPage, exact: true },
  { path: GlobalUrl.PassengerApp.Settings, component: PassengerSettingsPage, exact: true },
  { path: GlobalUrl.PassengerApp.Advertising, component: AdvertisingPage, exact: true },
  { path: GlobalUrl.PassengerApp.Passengers, component: PassengerAppUserPage, exact: true },
].map(x => ({ ...x, permissions: GlobalPermissionConfig.__getPermission(x.path) }));

export default routes;
